import React, { useState } from 'react';
import CandidateCard from '../FindCandidate/CandidateCard';
import Pagination from '../MyJobs/Pagination';
import useSavedCandidates from '../../Hooks/useSavedCandidates';
import { Heading } from '@/Components/ui/typography';
import { Separator } from '@/Components/ui/separator';

export default function SavedList({filter}) {
const candidates = useSavedCandidates();
// Debug log removed — was leaking saved candidates list (incl. PII) on every render.
    const [currentPage, setCurrentPage] = useState(1);
    const candidatesPerPage = 10;
    const indexOfLastCandidate = currentPage * candidatesPerPage;
    const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
    const currentCandidates = candidates.slice(indexOfFirstCandidate, indexOfLastCandidate);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    
    const totalPages = Math.ceil(candidates.length / candidatesPerPage);
    const handleUnSave = (candidate) => {
        // Debug log removed — was leaking candidate PII to console.
    };
    const filteredCandidates = filter
    ? candidates.filter((candidate) => candidate.jobTitle === filter)
    : candidates;

    return (
        <div className="flex flex-col w-full gap-5">
          <Heading level="h1" className="text-[26px] text-foreground">
            Saved Candidates
          </Heading>
          <div className="flex flex-col gap-5">
            {filteredCandidates.map((candidate, index) => (
              <React.Fragment key={index}>
                <CandidateCard candidate={candidate} onSave={handleUnSave} />
                {index < filteredCandidates.length - 1 && <Separator />}
              </React.Fragment>
            ))}
          </div>
          <div>
            <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
          </div>
        </div>
    );
}
